import LoginRouter from "./routes";

export default LoginRouter